import React from 'react'
import Helmet from 'react-helmet'

import Layout from '../components/layout'
import pic04 from '../assets/images/pic04.jpg'
import HeaderAvalingua from '../components/HeaderAvalingua'
import i18n from '../components/i18n'

class Avalingua extends React.Component {
  constructor(props) {
    super(props)
    i18n.changeLanguage('gl')
  }
  render() {
    return (
      <Layout>
        <Helmet title="Que é Avalingua?" />
        <HeaderAvalingua />
        <div id="main">
          <section id="content" className="main">
            <span className="image main">
              <img src={pic04} alt="" />
            </span>
            <h2>Que é Avalingua?</h2>
            <p>
              Avalingua avalía automáticamente a calidade lingüística dos
              textos, tanto en galego como en español (a versión para portugués
              está en desenvolvemento). Partindo dun texto escrito ou dun
              conxunto de textos, Avalingua fai unha análise pormenorizada
              mediante o uso de diferentes ferramentas de procesamento da lingua
              natural (PLN), incluíndo un analizador sintático de dependencias e
              variados recursos lingüísticos. Foi desenvolvido polo programa de
              Tecnoloxías da Linguaxe Natural do CiTIUS, Universidade de
              Santiago de Compostela, Galiza.
            </p>
            <h2>Que vantaxes ten esta tecnoloxía?</h2>
            <p>
              Permite ir alén dos correctores habituais, pois non só consegue
              detectar erros ortográficos e lexicais senón que tamén, grazas a
              un analizador sintáctico automático, identifica problemas
              gramaticais máis complexos entre palabras relacionadas
              sintácticamente mais que se encontran a moita distancia unhas das
              outras.
            </p>
            <h2>En que investigación está baseado Avalingua?</h2>
            <p>
              Avalingua é un conxunto de módulos de PLN de tecnoloxía híbrida,
              combinando coñecemento de expertos, heurísticas, recursos
              lingüísticos e aprendizaxe de máquina. O número de tipos de erros
              e problemas lingüísticos que se poden encontrar nos textos é tan
              elevado que está fóra do ámbito de calquera clasificador, pois non
              existen conxuntos de datos de entrenamento coa suficiente
              diversidade. Para a avaliación automática de textos, acreditamos
              que é preciso tecnoloxía híbrida que inclúa coñecemento explícito
              de expertos. O coñecemento sintáctico é codificado co sistema
              <i>DepPattern</i>, un analizador de dependencias compilado desde
              gramáticas provistas dun formalismo intuitivo para lingüistas.
            </p>
            <h2>Cales son as aplicacións de Avalingua?</h2>
            <p>
              A aplicación máis directa é no ámbito da educación, con dúas
              claras direccións: pode ser usado como sistema de monitorización e
              avaliación de estudantes de primaria e secundaria, ou/e como unha
              ferramenta de auto-aprendizaxe de linguas segundas para estudantes
              estranxeiros.
            </p>
          </section>
        </div>
      </Layout>
    )
  }
}

export default Avalingua
